module.exports = __webpack_public_path__ + "static/img/s62.8410e153.png";